import { Fetch } from '../helpers/fetchWrapper';
import { useEffect, useState } from 'react';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const productEnquiryService = {
  _url: `${process.env.REACT_APP_ENQUIRY_URL}`,

  GetProductEnquiries(searchQuery, refetch) {
    const [productEnquires, setProductEnquires] = useState({
      totalItems: 0,
      product_enquires: [],
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getProductProductEnquires(searchQuery))
        .then(res => {
          setProductEnquires(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), refetch]);
    return {
      product_enquires_loading: status === STATUS.LOADING,
      product_enquires_error: status === STATUS.ERROR ? status : '',
      product_enquires_data: productEnquires,
    };
  },

  async getProductProductEnquires({
    page = 1,
    pageSize = 10,
    searchText = '',
    startDate = '',
    endDate = '',
    getAll = false,
    filterCategory = '',
  }) {
    let res = await Fetch.get(
      `${this._url}/get-all-product-queries?page=${page}&itemsPerPage=${pageSize}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}&getAll=${getAll}&filterCategory=${filterCategory}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return {
        product_enquires: res?.items,
        totalItems: res?.totalItems,
      };
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async downloadProductEnquiryCSV({
    page = 1,
    itemsPerPage = '',
    searchText = '',
    startDate = '',
    endDate = '',
    getAll = false,
    filterCategory = '',
    filterProductQueries = '',
  }) {
    let res = await Fetch.exportFile(
      `${this._url}/export-all-product-queries?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&startDate=${startDate}&endDate=${endDate}&getAll=${getAll}&filterCategory=${filterCategory}&filterProductQueries=${filterProductQueries}`,
    );
    if (res.status >= 200 && res.status < 300) {
      return await res.blob();
    }

    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteEnquiry(id) {
    let res = await Fetch.delete(`${this._url}/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
};
export default productEnquiryService;
